import TemplateView from "../../../TemplateView"

export default class Node extends TemplateView {
    constructor(
        onClick = () => {}
    ) {
        super(null)

        this.onClick = onClick

        this.state = {
            selected: false
        }

        this.onStateChanged(() => this._updateClasses())
    }

    afterRender() {
        this.$el.click((e) => {
            if (this.preventNextClick) {
                this.preventNextClick = false
                return
            }
            this.onClick()
        })
    }

    _updateClasses() {
        this.$el.toggleClass("selected", this.state.selected)
        this.$el.toggleClass("notSelected", !this.state.selected)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/Node.js